module.exports = __webpack_public_path__ + "static/media/hero_banner.02fe4eb6.png";